import { MapPin } from "lucide-react";
import { ChapterTag, MaskedLines, FadeUp } from "./Reveal";
import { BookButton } from "./CTA";
import { SITE } from "../config/site";

const NODES = [
  { name: "Delhi", x: 200, y: 120, primary: true },
  { name: "Gurugram", x: 115, y: 235, primary: true },
  { name: "Noida", x: 315, y: 165, primary: true },
];

export const ServiceArea = () => (
  <section id="areas" data-testid="areas-section" className="py-24 lg:py-32 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <ChapterTag index="08" label="Coverage" />
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 mt-10 items-center">
        <div>
          <h2 data-testid="areas-headline" className="font-display font-semibold text-charcoal tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
            <MaskedLines lines={[<>Professional pest control</>, <span className="italic text-wine">across Delhi NCR.</span>]} />
          </h2>
          <FadeUp delay={0.3} className="mt-7 max-w-lg">
            <p className="text-stone2 leading-relaxed">
              We are a local operating company — not a call centre. Our technicians serve homes and businesses across the capital region, with same-day inspection slots subject to availability.
            </p>
          </FadeUp>
          <FadeUp delay={0.4} className="mt-8 space-y-3">
            {SITE.primaryAreas.map((a) => (
              <div key={a} data-testid={`area-${a.toLowerCase()}`} className="flex items-center gap-3 border-b border-border pb-3">
                <MapPin className="h-4 w-4 text-wine" strokeWidth={1.75} />
                <span className="font-display text-2xl font-semibold text-charcoal">{a}</span>
                <span className="ml-auto text-[10px] tracking-[0.25em] uppercase font-bold text-gold">Primary</span>
              </div>
            ))}
          </FadeUp>
          <FadeUp delay={0.5} className="mt-6 flex flex-wrap gap-2">
            {SITE.extraAreas.map((a) => (
              <span key={a} className="border border-dashed border-border px-3.5 py-1.5 text-[12px] font-semibold text-stone2">{a}</span>
            ))}
            <span className="px-1 py-1.5 text-[11px] italic text-stone2/80">Additional locations being confirmed — editable placeholders.</span>
          </FadeUp>
          <FadeUp delay={0.6} className="mt-9">
            <BookButton testid="areas-book-btn" />
          </FadeUp>
        </div>

        <FadeUp delay={0.35}>
          <div className="relative border border-border bg-cream p-6 lg:p-10" data-testid="ncr-map">
            <span className="absolute top-4 left-5 text-[10px] tracking-[0.3em] uppercase font-bold text-stone2">Delhi NCR · Service Map</span>
            <svg viewBox="0 0 430 320" className="w-full h-auto" role="img" aria-label="Stylized map highlighting Delhi, Gurugram and Noida">
              <path d="M200 120 L115 235" stroke="#B38F5A" strokeWidth="1.5" strokeDasharray="5 6" fill="none" />
              <path d="M200 120 L315 165" stroke="#B38F5A" strokeWidth="1.5" strokeDasharray="5 6" fill="none" />
              <path d="M115 235 L315 165" stroke="#B38F5A" strokeWidth="1" strokeDasharray="3 7" fill="none" opacity="0.5" />
              {NODES.map((n) => (
                <g key={n.name}>
                  <circle cx={n.x} cy={n.y} r="34" fill="#5B1825" opacity="0.06" />
                  <circle cx={n.x} cy={n.y} r="18" fill="#5B1825" opacity="0.12">
                    <animate attributeName="r" values="14;22;14" dur="3s" repeatCount="indefinite" />
                    <animate attributeName="opacity" values="0.18;0.05;0.18" dur="3s" repeatCount="indefinite" />
                  </circle>
                  <circle cx={n.x} cy={n.y} r="7" fill="#5B1825" />
                  <circle cx={n.x} cy={n.y} r="2.5" fill="#B38F5A" />
                  <text x={n.x} y={n.y - 24} textAnchor="middle" fill="#1A1A1A" fontSize="17" fontWeight="600" fontFamily="Cormorant Garamond, serif">{n.name}</text>
                </g>
              ))}
            </svg>
            <p className="text-[11px] text-stone2 mt-2 text-center italic">Stylized coverage illustration — Delhi · Gurugram · Noida</p>
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
